/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Haben Sie ein Konto?`
};

const en_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Do you have an account?`
};

const es_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Tienes una cuenta?`
};

const fr_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Avez-vous un compte ?`
};

const it_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Hai un account?`
};

const nl_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Heeft u een account?`
};

const pt_register_car__account_title = /** @type {(inputs: {}) => string} */ () => {
	return `Possui uma conta?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__account_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__account_title", locale)
	if (locale === "de") return de_register_car__account_title(inputs)
	if (locale === "en") return en_register_car__account_title(inputs)
	if (locale === "es") return es_register_car__account_title(inputs)
	if (locale === "fr") return fr_register_car__account_title(inputs)
	if (locale === "it") return it_register_car__account_title(inputs)
	if (locale === "nl") return nl_register_car__account_title(inputs)
	return pt_register_car__account_title(inputs)
};